import React, { useEffect, useRef, useState } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {
  DownloadOutlined,
  NotificationsActiveOutlined,
  NotificationsOffOutlined,
  RestartAlt,
} from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";
import closeIcon from "../../images/close-icon.png";
import DummyAgentImage from "../../images/DummyAgent.svg";
import LanguageToggle from "../../utils/LanguageToggle/LanguageToggle";
import { isNullOrUndefined } from "../HWLibrary/HWUtils";
import { s360ConfigService } from "../Services/S360Config";
import { useNetworkStatus } from "../../context/NetworkContext";
import "./ConversationStyleSheet.css";
import apiService from "../Services/APIService";
import { minHeight } from "@mui/system";
import {
  DATA_TEST_ID_PREFIX,
  DATA_TEST_ID_PREFIX_CONNECT_TO_NEXTIVA,
  LIVECHAT_CLICK_EVENTS,
} from "../../utils/Constants/statsig.constants";

function ConversationHeader(props) {
  const { isOnline, networkQuality, latency } = useNetworkStatus();
  const menuContainerRef = useRef();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [smallWindow, setSmallWindow] = useState(false);
  const [previewHeaderStyles, setPreviewHeaderStyles] = useState({});
  const isFullScreen = localStorage.getItem("openInFullScreen");
  const isMobile = s360ConfigService.getConfig()?.isMobile; // Get isMobile from config
  const isSandbox = s360ConfigService?.config?.sandBox; // Get sandbox status

  let isActiveConversation = props.isActiveConversation();
  let canDownloadTranscript =
    s360ConfigService.config?.configDetails?.sendChatTranscript;
  let statusColor = props?.conversation?.agentInfo?.isActive
    ? "#e60000"
    : "#00cc00";
  let notificationEnabled = s360ConfigService?.config?.notification?.isEnabled;
  let isManualSessionActionEnabled =
    s360ConfigService.config?.configDetails?.allowManualSessionEnd;

  let showMizimizeOnFullScreen =
    s360ConfigService?.config?.showMinimizeIconInFullScreen;
  const showChatHistoryOption = () => {
    let showChatHistory = false;
    if (
      s360ConfigService?.config?.anonymous &&
      s360ConfigService?.config?.connectToNextiva
    ) {
      // special to connect to nextiva
      showChatHistory = true;
    } else if (
      !s360ConfigService?.config?.hideChatHis &&
      !s360ConfigService?.config?.anonymous
    ) {
      showChatHistory = true;
    }

    return showChatHistory;
  };
  const isAnyMenuActionsEnabled =
    canDownloadTranscript ||
    isManualSessionActionEnabled ||
    notificationEnabled ||
    showChatHistoryOption();

  let hideHis = props.config.hideChatHis;
  let showLogo = isNullOrUndefined(props.config.showLogo)
    ? true
    : props.config.showLogo;

  const { isShowToggle } = props;
  const customDesign = props.config?.customDesign ?? {};

  const onClose = () => {
    if (s360ConfigService.config.sandBox) {
      return;
    }
    window.parent.postMessage(
      {
        minimize: "true",
      },
      "*"
    );
    props.actions.setIsAppOpen(false);
    if (typeof props.actions?.onHideChatWindow === "function") {
      props.actions.onHideChatWindow();
    }

    // props.actions.onStartUpClick();
  };

  const closeOnFullScreen = () => {
    window.parent.postMessage(
      {
        closeFunctionFullScreen: "true",
      },
      "*"
    );
  };

  const onSendChatTranscriptClick = () => {
    setIsMenuOpen(false);
    props.onSendChatTranscriptClick();
  };

  const closeConversationClick = () => {
    // if (props.showCloseDialog) {
    //   props.restartNCXConversation();
    // }
    if (s360ConfigService.config?.sandBox) return;
    let tempIsFullScreen = localStorage.getItem("openInFullScreen");
    props.setShowNcxChatHistory(false);
    //todo : bob
    if (tempIsFullScreen) {
      closeOnFullScreen();
    } else {
      setIsMenuOpen(false);
      props.closeConversationClick();
    }
  };

  const parseName = () => {
    const agentInfo = sessionStorage.getItem("agentName");

    return agentInfo
      ? agentInfo
      : s360ConfigService?.config?.configDetails?.brandName;
  };

  const menuOptionImage = (visible) => {
    return (
      <Tooltip
        title={isOnline ? "More options" : "Not available during offline"}
        disableHoverListener={isSandbox}
        placement="top"
        slotProps={{
          popper: {
            modifiers: [
              {
                name: "preventOverflow",
                options: {
                  boundary: "window",
                },
              },
            ],
          },
          tooltip: {
            sx: {
              display: isMobile ? "none" : "block",
              backgroundColor: "#222648 !important",
              borderRadius: "4px",
              width: "auto",
              height: "auto",
              padding: "8px 16px",
              marginBottom: "10%",
              fontFamily: "Lato",
              fontWeight: 400,
              fontSize: "12px",
              lineHeight: "16px",
              letterSpacing: "0.15px",
              textAlign: "center",
            },
          },
        }}
      >
        <svg
          width="13"
          height="4"
          viewBox="0 0 13 4"
          fill="none"
          opacity={isOnline && !props.sessionClosedbyAgent ? "1" : "0.5"}
          xmlns="http://www.w3.org/2000/svg"
          onClick={
            isOnline && !props.sessionClosedbyAgent ? onMenuAction : undefined
          }
        >
          <path
            d="M12.1875 1.75C12.1875 2.24219 11.9141 2.65234 11.5312 2.89844C11.1211 3.14453 10.6016 3.14453 10.2188 2.89844C9.80859 2.65234 9.5625 2.24219 9.5625 1.75C9.5625 1.28516 9.80859 0.875 10.2188 0.628906C10.6016 0.382812 11.1211 0.382812 11.5312 0.628906C11.9141 0.875 12.1875 1.28516 12.1875 1.75ZM7.8125 1.75C7.8125 2.24219 7.53906 2.65234 7.15625 2.89844C6.74609 3.14453 6.22656 3.14453 5.84375 2.89844C5.43359 2.65234 5.1875 2.24219 5.1875 1.75C5.1875 1.28516 5.43359 0.875 5.84375 0.628906C6.22656 0.382812 6.74609 0.382812 7.15625 0.628906C7.53906 0.875 7.8125 1.28516 7.8125 1.75ZM2.125 3.0625C1.63281 3.0625 1.22266 2.81641 0.976562 2.40625C0.730469 2.02344 0.730469 1.50391 0.976562 1.09375C1.22266 0.710938 1.63281 0.4375 2.125 0.4375C2.58984 0.4375 3 0.710938 3.24609 1.09375C3.49219 1.50391 3.49219 2.02344 3.24609 2.40625C3 2.81641 2.58984 3.0625 2.125 3.0625Z"
            fill="white"
          />
        </svg>
      </Tooltip>
    );
  };

  const menuOptionClose = () => setIsMenuOpen(false);

  const onMenuAction = () => setIsMenuOpen(true);

  const onBackAction = () => {
    // if (!s360ConfigService.config.isNewConversation) {
    //   s360ConfigService.activeSessions[props.conversation.workitemId] = {
    //     chatMessages: [],
    //   };
    // }
    // s360ConfigService.config.isNewConversation = false;
    // props.actions.showLandingScreen();
    props.setShowNcxChatHistory(true);
    menuOptionClose();
  };

  useEffect(() => {
    if (s360ConfigService?.config?.preview) {
      setPreviewHeaderStyles({
        background: "#fff",
        height: "3rem",
        contentVisibility: "hidden",
      });
    }
  }, [s360ConfigService?.config]);
  const handleWindowSizeToggle = (value) => {
    const message = value ? { smallWindow: "true" } : { normalWindow: "true" };
    window.parent.postMessage(message, "*");

    setSmallWindow(value);
  };

  const menuItemStyles = {
    fontFamily: "Lato",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px",
    textAlign: "left",
    minHeight: "40px",
    fontWeight: 400 + "!important",
  };

  const handleClickClose = () => {
    closeConversationClick();
  };

  return (
    <div
      className="s360-conversation-header-container"
      style={{
        ...customDesign?.conversationHeaderContainer,
        ...previewHeaderStyles,
        // contentVisibility: s360ConfigService?.config?.preview
        //   ? "hidden"
        //   : "auto",

        // background: s360ConfigService?.config?.preview ? "#fff" : "#5c3d3d",

        // height: s360ConfigService?.config?.preview ? "3rem" : "70px",
      }}
    >
      <div
        style={{
          width: "100%",

          marginLeft: 12,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* {!hideHis &&
          !s360ConfigService?.config?.sandBox &&
          s360ConfigService?.config?.configDetails?.showForm &&
          !s360ConfigService?.config?.anonymous && (
            <div className="s360-conversation-header-back-button-container">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 24 24"
                onClick={() => onBackAction()}
                fill={
                  s360ConfigService?.config?.configDetails?.primaryFontColor
                }
                style={customDesign?.conversationHeaderBackButton}
              >
                <path d="M 10 5.3417969 C 9.744125 5.3417969 9.4879688 5.4412187 9.2929688 5.6367188 L 3.6367188 11.292969 C 3.2457187 11.683969 3.2457187 12.317031 3.6367188 12.707031 L 9.2929688 18.363281 C 9.6839688 18.754281 10.317031 18.754281 10.707031 18.363281 L 10.792969 18.277344 C 11.183969 17.886344 11.183969 17.253281 10.792969 16.863281 L 6.9296875 13 L 20 13 C 20.552 13 21 12.552 21 12 C 21 11.448 20.552 11 20 11 L 6.9296875 11 L 10.792969 7.1367188 C 11.183969 6.7457187 11.183969 6.1126563 10.792969 5.7226562 L 10.707031 5.6367188 C 10.511531 5.4412187 10.255875 5.3417969 10 5.3417969 z"></path>
              </svg>
            </div>
          )} */}
        {s360ConfigService?.config?.connectToNextiva &&
          !s360ConfigService.getConfig()?.isMobile && (
            <div style={{ marginRight: "1rem" }}>
              {!smallWindow ? (
                <Tooltip
                  slotProps={{
                    popper: {
                      modifiers: [
                        {
                          name: "preventOverflow",
                          options: {
                            boundary: "window",
                          },
                        },
                      ],
                    },
                    tooltip: {
                      sx: {
                        backgroundColor: "#222648 !important",
                        borderRadius: "4px",
                        width: "auto",
                        height: "auto",
                        padding: "8px 16px",
                        marginBottom: "10%",
                        fontFamily: "Lato",
                        fontWeight: 400,
                        fontSize: "12px",
                        lineHeight: "16px",
                        letterSpacing: "0.15px",
                        textAlign: "center",
                      },
                    },
                  }}
                  title="Collapse chat"
                  placement="top"
                  disableHoverListener={isSandbox}
                >
                  <svg
                    onClick={() => {
                      if (s360ConfigService.config.sandBox) {
                        return;
                      }
                      handleWindowSizeToggle(true);
                    }}
                    width="16"
                    height="15"
                    viewBox="0 0 16 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    data-testid={`${
                      s360ConfigService?.config?.connectToNextiva
                        ? DATA_TEST_ID_PREFIX_CONNECT_TO_NEXTIVA
                        : DATA_TEST_ID_PREFIX
                    }-${LIVECHAT_CLICK_EVENTS.COMMON_HEADER_TOGGLE_SIZE}`}
                  >
                    <path
                      d="M13.0039 0.941406C13.25 0.695312 13.6602 0.695312 13.9062 0.941406L14.7812 1.81641C15.0547 2.08984 15.0547 2.5 14.7812 2.74609L12.4023 5.125L13.4688 6.19141C13.6602 6.38281 13.7148 6.68359 13.6328 6.92969C13.5234 7.17578 13.2773 7.3125 13.0039 7.3125H9.09375C8.71094 7.3125 8.4375 7.03906 8.4375 6.65625V2.71875C8.4375 2.47266 8.57422 2.22656 8.82031 2.11719C9.06641 2.03516 9.36719 2.08984 9.55859 2.25391L10.625 3.32031L13.0039 0.941406ZM2.96875 8.1875H6.90625C7.26172 8.1875 7.5625 8.48828 7.5625 8.84375V12.7812C7.5625 13.0547 7.39844 13.3008 7.15234 13.4102C6.90625 13.4922 6.60547 13.4375 6.44141 13.2461L5.375 12.1797L2.99609 14.5586C2.72266 14.832 2.3125 14.832 2.06641 14.5586L1.19141 13.6836C0.917969 13.4375 0.917969 13.0273 1.19141 12.7812L3.57031 10.4023L2.50391 9.30859C2.3125 9.14453 2.25781 8.84375 2.33984 8.59766C2.44922 8.35156 2.69531 8.1875 2.96875 8.1875Z"
                      fill={
                        s360ConfigService.config?.configDetails
                          ?.primaryFontColor ?? "rgb(1, 95, 235)"
                      }
                    />
                  </svg>
                </Tooltip>
              ) : (
                <Tooltip
                  slotProps={{
                    popper: {
                      modifiers: [
                        {
                          name: "preventOverflow",
                          options: {
                            boundary: "window",
                          },
                        },
                      ],
                    },
                    tooltip: {
                      sx: {
                        backgroundColor: "#222648 !important",
                        borderRadius: "4px",
                        width: "auto",
                        height: "auto",
                        padding: "8px 16px",
                        marginBottom: "10%",
                        fontFamily: "Lato",
                        fontWeight: 400,
                        fontSize: "12px",
                        lineHeight: "16px",
                        letterSpacing: "0.15px",
                        textAlign: "center",
                      },
                    },
                  }}
                  title="Expand chat"
                  placement="top"
                  disableHoverListener={isSandbox}
                >
                  <svg
                    onClick={() => {
                      if (s360ConfigService.config.sandBox) {
                        return;
                      }
                      handleWindowSizeToggle(false);
                    }}
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    data-testid={`${
                      s360ConfigService?.config?.connectToNextiva
                        ? DATA_TEST_ID_PREFIX_CONNECT_TO_NEXTIVA
                        : DATA_TEST_ID_PREFIX
                    }-${LIVECHAT_CLICK_EVENTS.COMMON_HEADER_TOGGLE_SIZE}`}
                  >
                    <path
                      d="M9.40625 0.75H13.3438C13.6992 0.75 14 1.05078 14 1.40625V5.34375C14 5.61719 13.8359 5.86328 13.5898 5.97266C13.3438 6.05469 13.043 6 12.8789 5.80859L11.8125 4.74219L9.43359 7.12109C9.16016 7.39453 8.75 7.39453 8.50391 7.12109L7.62891 6.24609C7.35547 6 7.35547 5.58984 7.62891 5.34375L10.0078 2.96484L8.94141 1.87109C8.75 1.70703 8.69531 1.40625 8.77734 1.16016C8.88672 0.914062 9.13281 0.75 9.40625 0.75ZM4.59375 14.75H0.65625C0.273438 14.75 0 14.4766 0 14.0938V10.1562C0 9.91016 0.136719 9.66406 0.382812 9.55469C0.628906 9.47266 0.929688 9.52734 1.12109 9.69141L2.1875 10.7578L4.56641 8.37891C4.8125 8.13281 5.22266 8.13281 5.46875 8.37891L6.34375 9.25391C6.61719 9.52734 6.61719 9.9375 6.34375 10.1836L3.96484 12.5625L5.03125 13.6289C5.22266 13.8203 5.27734 14.1211 5.19531 14.3672C5.08594 14.6133 4.83984 14.75 4.56641 14.75H4.59375Z"
                      fill={
                        s360ConfigService.config?.configDetails
                          ?.primaryFontColor ?? "rgb(1, 95, 235)"
                      }
                    />
                  </svg>
                </Tooltip>
              )}
            </div>
          )}
        {isAnyMenuActionsEnabled ? (
          <div
            ref={menuContainerRef}
            className="menu-item"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            {isAnyMenuActionsEnabled &&
              !props.showNcxChatHistory &&
              menuOptionImage(isAnyMenuActionsEnabled)}

            {isAnyMenuActionsEnabled && (
              <Menu
                key={"options-menu-" + isMenuOpen}
                anchorEl={menuContainerRef.current}
                open={!!isMenuOpen}
                onClose={menuOptionClose}
              >
                <div>
                  {(isMobile || isManualSessionActionEnabled) && (
                    <MenuItem
                      className="s360-conversation-header-options-menu-item"
                      style={{
                        ...customDesign?.conversationHeaderOptionsMenuItem,
                        ...menuItemStyles,
                      }}
                      onClick={() => {
                        if (s360ConfigService.config.sandBox) {
                          return;
                        }
                        props.restartNCXConversation(true);
                        setIsMenuOpen(false);
                      }}
                      data-testid={`${
                        s360ConfigService?.config?.connectToNextiva
                          ? DATA_TEST_ID_PREFIX_CONNECT_TO_NEXTIVA
                          : DATA_TEST_ID_PREFIX
                      }-${
                        LIVECHAT_CLICK_EVENTS.COMMON_HEADER_START_NEW_COVERSATION
                      }`}
                    >
                      <svg
                        width="18"
                        height="15"
                        viewBox="0 0 18 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.5625 2.71875V7.53125C1.5625 7.91406 1.83594 8.1875 2.21875 8.1875H3.53125C3.88672 8.1875 4.1875 8.48828 4.1875 8.84375V9.39062L5.77344 8.29688C5.88281 8.24219 6.01953 8.1875 6.15625 8.1875H9.65625C10.0117 8.1875 10.3125 7.91406 10.3125 7.53125V2.71875C10.3125 2.36328 10.0117 2.0625 9.65625 2.0625H2.21875C1.83594 2.0625 1.5625 2.36328 1.5625 2.71875ZM2.21875 0.75H9.65625C10.7227 0.75 11.625 1.65234 11.625 2.71875V7.53125C11.625 8.625 10.7227 9.5 9.65625 9.5H6.34766L3.88672 11.1406C3.69531 11.2773 3.42188 11.3047 3.20312 11.1953C2.98438 11.0586 2.875 10.8398 2.875 10.5938V9.5H2.21875C1.125 9.5 0.25 8.625 0.25 7.53125V2.71875C0.25 1.65234 1.125 0.75 2.21875 0.75ZM7.25 11.0312V10.375H8.5625V11.0312C8.5625 11.4141 8.83594 11.6875 9.21875 11.6875H11.8438C11.9531 11.6875 12.0898 11.7422 12.1992 11.7969L13.8125 12.8906V12.3438C13.8125 11.9883 14.0859 11.6875 14.4688 11.6875H15.7812C16.1367 11.6875 16.4375 11.4141 16.4375 11.0312V6.21875C16.4375 5.86328 16.1367 5.5625 15.7812 5.5625H12.5V4.25H15.7812C16.8477 4.25 17.75 5.15234 17.75 6.21875V11.0312C17.75 12.125 16.8477 13 15.7812 13H15.125V14.0938C15.125 14.3398 14.9883 14.5586 14.7695 14.6953C14.5508 14.8047 14.3047 14.7773 14.0859 14.6406L11.625 13H9.21875C8.125 13 7.25 12.125 7.25 11.0312Z"
                          fill="#7A7D8C"
                        />
                      </svg>
                      <span> Start new conversation</span>
                    </MenuItem>
                  )}
                  {/* {placeholder for jumping action items
                  basically 1st 4 options.map((action)=><Menu onclick={
                  startConversationFromAction(action.compID)
                  //will be taken care in M2}/>)} */}
                </div>
                {!isMobile && ( // Render other menu items only if not mobile
                  <div>
                    <div
                      style={{
                        borderBottom: "1px solid #EDEFF4",
                      }}
                    />
                    <div>
                      {showChatHistoryOption() && (
                        <MenuItem
                          className="s360-conversation-header-options-menu-item"
                          style={{
                            ...customDesign?.conversationHeaderOptionsMenuItem,
                            ...menuItemStyles,
                            fontWeight: 400,
                          }}
                          onClick={() => {
                            if (s360ConfigService?.config?.sandBox) return;
                            onBackAction();
                          }}
                          data-testid={`${
                            s360ConfigService?.config?.connectToNextiva
                              ? DATA_TEST_ID_PREFIX_CONNECT_TO_NEXTIVA
                              : DATA_TEST_ID_PREFIX
                          }-${
                            LIVECHAT_CLICK_EVENTS.COMMON_HEADER_CHAT_HISTORY
                          }`}
                        >
                          <RestartAlt style={{ fill: "#7A7D8C" }} />
                          <span> Chat history</span>
                        </MenuItem>
                      )}
                      {canDownloadTranscript && (
                        <MenuItem
                          className="s360-conversation-header-options-menu-item"
                          style={{
                            ...customDesign?.conversationHeaderOptionsMenuItem,
                            ...menuItemStyles,
                          }}
                          onClick={() => {
                            if (s360ConfigService.config.sandBox) {
                              return;
                            }
                            onSendChatTranscriptClick();
                          }}
                          data-testid={`${
                            s360ConfigService?.config?.connectToNextiva
                              ? DATA_TEST_ID_PREFIX_CONNECT_TO_NEXTIVA
                              : DATA_TEST_ID_PREFIX
                          }-${
                            LIVECHAT_CLICK_EVENTS.COMMON_HEADER_DOWNLOAD_TRANSCRIPT
                          }`}
                        >
                          <DownloadOutlined style={{ fill: "#7A7D8C" }} />
                          <span> Download transcript</span>
                        </MenuItem>
                      )}
                      {notificationEnabled && (
                        <MenuItem
                          className="s360-conversation-header-options-menu-item"
                          style={{
                            ...customDesign?.conversationHeaderOptionsMenuItem,
                            ...menuItemStyles,
                          }}
                          onClick={() => {
                            if (s360ConfigService.config.sandBox) {
                              return;
                            }
                            let tempPlaySound = props?.playSound;

                            props.muteNotification(!tempPlaySound);
                          }}
                          data-testid={`${
                            s360ConfigService?.config?.connectToNextiva
                              ? DATA_TEST_ID_PREFIX_CONNECT_TO_NEXTIVA
                              : DATA_TEST_ID_PREFIX
                          }-${
                            props?.playSound
                              ? LIVECHAT_CLICK_EVENTS.COMMON_HEADER_MUTE_NOTIFICATION
                              : LIVECHAT_CLICK_EVENTS.COMMON_HEADER_UNMUTE_NOTIFICATION
                          }`}
                        >
                          {props.playSound ? (
                            <>
                              <NotificationsOffOutlined
                                style={{ fill: "#7A7D8C" }}
                              />
                              <span>Mute Notification</span>
                            </>
                          ) : (
                            <>
                              <NotificationsActiveOutlined
                                style={{ fill: "#7A7D8C" }}
                              />
                              <span>Unmute Notification</span>
                            </>
                          )}
                        </MenuItem>
                      )}
                    </div>
                  </div>
                )}
              </Menu>
            )}
            {/* {canDownloadTranscript && !isActiveConversation && (
              <div
                onClick={onSendChatTranscriptClick}
                style={{ cursor: "pointer" }}
              />
            )} */}
            {/* {isManualSessionActionEnabled &&
              !canDownloadTranscript &&
              isActiveConversation &&
              (isNullOrUndefined(props.config.forceCloseButton)
                ? true
                : props.config.forceCloseButton) && (
                <div
                  style={{ cursor: "pointer" }}
                  onClick={closeConversationClick}
                >
                  <img height={10} width={10} src={closeIcon} alt=""></img>
                </div>
              )} */}
          </div>
        ) : null}
        {showLogo &&
          s360ConfigService?.config?.configDetails?.brandIcon !== "" && (
            <div
              className={`s360-conversation-header-details-image${
                isFullScreen ? "-fs" : ""
              }`}
            >
              <div
                id="headerImgDiv"
                style={{
                  fontSize: "15px",
                  textAlign: "center",
                  width: "2em",
                  height: "2em",
                  display: " inline-flex",
                }}
              >
                <img
                  id="s360-agent-image"
                  className="s360-conversation-header-logo-icon"
                  style={customDesign?.conversationHeaderLogoIcon}
                  src={props.config.configDetails?.brandIcon || DummyAgentImage}
                  alt=""
                ></img>
              </div>
            </div>
          )}
        <div
          style={{
            width: "15% !important",
            height: "100% !important",
            display: "flex",
            alignItems: "center",
            paddingBottom: "14px",
          }}
        >
          {!props.config?.configDetails?.disableTypingIndicatorStatus && (
            <div className="s360-conversation-header-agent-ping-status-container">
              <div
                className="s360-conversation-header-agent-ping-status"
                style={{ backgroundColor: statusColor }}
              />
            </div>
          )}
        </div>
        <div
          style={{
            flexGrow: 1,
            display: "flex",
            flexDirection: props.config.configDetails
              ?.disableTypingIndicatorStatus
              ? "row"
              : "column",
            justifyContent: "center",
            marginLeft: isFullScreen ? "0%" : "2%",
          }}
        >
          <div
            className={`s360-conversation-header-details-title${
              isFullScreen ? "-fs" : ""
            }`}
          >
            <span>{parseName()}</span>
          </div>
          {/* {!props.config.configDetails?.disableTypingIndicatorStatus && (
            <div className="s360-conversation-typing-indicator">ACTIVE NOW</div>
          )} */}
        </div>
      </div>
      <div
        className={`s360-conversation-header-container-menu-container${
          isFullScreen ? "-fs" : ""
        }`}
      >
        {/* <LanguageToggle />  */}
        {props.config.languageSwitcher && isShowToggle && (
          <LanguageToggle {...props} />
        )}

        {isFullScreen && !s360ConfigService?.getConfig().isMobile ? (
          showMizimizeOnFullScreen ? (
            <div
              className="s360-conversation-header-icon-container"
              onClick={onClose}
              style={{
                display: s360ConfigService?.config?.preview ? "none" : "flex",
              }}
              data-testid={`${
                s360ConfigService?.config?.connectToNextiva
                  ? DATA_TEST_ID_PREFIX_CONNECT_TO_NEXTIVA
                  : DATA_TEST_ID_PREFIX
              }-${LIVECHAT_CLICK_EVENTS.COMMON_HEADER_MINIMIZE}`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13.624"
                height="53px"
                viewBox="0 0 13.624 8.209"
              >
                <path
                  id="down-arrow"
                  d="M2370.983,5063.169a1,1,0,0,1-.73-.316l-5.812-6.209a1,1,0,0,1,1.46-1.367l5.082,5.429,5.082-5.429a1,1,0,0,1,1.46,1.367l-5.812,6.209A1,1,0,0,1,2370.983,5063.169Z"
                  transform="translate(-2364.171 -5054.96)"
                  className="s360-conversation-header-down-icon"
                  fill={
                    s360ConfigService.config?.configDetails?.primaryFontColor ??
                    "rgb(1, 95, 235)"
                  }
                />
              </svg>
            </div>
          ) : (
            <div
              className="s360-conversation-header-icon-container"
              onClick={isOnline ? closeConversationClick : undefined}
              style={{
                opacity: isOnline ? "1" : "0.5",
                display:
                  s360ConfigService?.config?.preview ||
                  !s360ConfigService?.getConfig().isMobile
                    ? "none"
                    : "flex",
              }}
              data-testid={`${
                s360ConfigService?.config?.connectToNextiva
                  ? DATA_TEST_ID_PREFIX_CONNECT_TO_NEXTIVA
                  : DATA_TEST_ID_PREFIX
              }-${
                s360ConfigService?.config?.connectToNextiva
                  ? LIVECHAT_CLICK_EVENTS.COMMON_HEADER_MINIMIZE
                  : LIVECHAT_CLICK_EVENTS.COMMON_HEADER_END_CHAT
              }`}
            >
              <svg
                opacity={isOnline ? "1" : "0.5"}
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.7812 2.28125L7.03125 6.03125L10.75 9.75C11.0625 10.0312 11.0625 10.5 10.75 10.7812C10.4688 11.0938 10 11.0938 9.71875 10.7812L5.96875 7.0625L2.25 10.7812C1.96875 11.0938 1.5 11.0938 1.21875 10.7812C0.90625 10.5 0.90625 10.0312 1.21875 9.71875L4.9375 6L1.21875 2.28125C0.90625 2 0.90625 1.53125 1.21875 1.21875C1.5 0.9375 1.96875 0.9375 2.28125 1.21875L6 4.96875L9.71875 1.25C10 0.9375 10.4688 0.9375 10.7812 1.25C11.0625 1.53125 11.0625 2 10.7812 2.28125Z"
                  fill={
                    s360ConfigService.config?.configDetails?.primaryFontColor ??
                    "rgb(1, 95, 235)"
                  }
                />
              </svg>
            </div>
          )
        ) : (
          !isMobile && (
            // &&
            //   !s360ConfigService?.getConfig().isMobile
            <div
              style={{
                display: "flex",

                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "3.5rem",
              }}
            >
              <Tooltip
                slotProps={{
                  popper: {
                    modifiers: [
                      {
                        name: "preventOverflow",
                        options: {
                          boundary: "window",
                        },
                      },
                    ],
                  },
                  tooltip: {
                    sx: {
                      display: isMobile ? "none" : "block",
                      backgroundColor: "#222648 !important",
                      borderRadius: "4px",
                      width: "auto",
                      height: "auto",
                      padding: "8px 16px",
                      marginBottom: "10%",
                      fontFamily: "Lato",
                      fontWeight: 400,
                      fontSize: "12px",
                      lineHeight: "16px",
                      letterSpacing: "0.15px",
                      textAlign: "center",
                    },
                  },
                }}
                title="Minimize Chat"
                placement="top"
                disableHoverListener={isSandbox}
              >
                <div
                  className="s360-conversation-header-icon-container"
                  onClick={onClose}
                  style={{
                    display: s360ConfigService?.config?.preview
                      ? "none"
                      : "flex",
                    justifyContent: props.sessionClosedbyAgent
                      ? "end"
                      : "center",
                  }}
                  data-testid={`${
                    s360ConfigService?.config?.connectToNextiva
                      ? DATA_TEST_ID_PREFIX_CONNECT_TO_NEXTIVA
                      : DATA_TEST_ID_PREFIX
                  }-${LIVECHAT_CLICK_EVENTS.COMMON_HEADER_MINIMIZE}`}
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 9 3"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.125 1.75C0.125 1.28516 0.507812 0.875 1 0.875H8C8.46484 0.875 8.875 1.28516 8.875 1.75C8.875 2.24219 8.46484 2.625 8 2.625H1C0.507812 2.625 0.125 2.24219 0.125 1.75Z"
                      fill={
                        s360ConfigService.config?.configDetails
                          ?.primaryFontColor ?? "rgb(1, 95, 235)"
                      }
                    />
                  </svg>
                </div>
              </Tooltip>
              {isMobile ? null : (
                <Tooltip
                  slotProps={{
                    popper: {
                      modifiers: [
                        {
                          name: "preventOverflow",
                          options: {
                            boundary: "window",
                          },
                        },
                      ],
                    },
                    tooltip: {
                      sx: {
                        backgroundColor: "#222648 !important",
                        borderRadius: "4px",
                        width: "auto",
                        height: "auto",
                        padding: "8px 16px",
                        marginBottom: "10%",
                        fontFamily: "Lato",
                        fontWeight: 400,
                        fontSize: "12px",
                        lineHeight: "16px",
                        letterSpacing: "0.15px",
                        textAlign: "center",
                      },
                    },
                  }}
                  title={
                    isOnline ? "End Chat" : "Not availiable during offline"
                  }
                  placement="top"
                >
                  <div
                    className="s360-conversation-header-icon-container"
                    onClick={isOnline ? handleClickClose : null}
                    style={{
                      marginLeft: "5px",
                      display: s360ConfigService?.config?.preview
                        ? "none"
                        : "flex",
                    }}
                  >
                    <svg
                      title="Close conversation"
                      width="16"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      opacity={isOnline ? "1" : "0.5"}
                    >
                      <path
                        d="M10.7812 2.28125L7.03125 6.03125L10.75 9.75C11.0625 10.0312 11.0625 10.5 10.75 10.7812C10.4688 11.0938 10 11.0938 9.71875 10.7812L5.96875 7.0625L2.25 10.7812C1.96875 11.0938 1.5 11.0938 1.21875 10.7812C0.90625 10.5 0.90625 10.0312 1.21875 9.71875L4.9375 6L1.21875 2.28125C0.90625 2 0.90625 1.53125 1.21875 1.21875C1.5 0.9375 1.96875 0.9375 2.28125 1.21875L6 4.96875L9.71875 1.25C10 0.9375 10.4688 0.9375 10.7812 1.25C11.0625 1.53125 11.0625 2 10.7812 2.28125Z"
                        fill={
                          s360ConfigService.config?.configDetails
                            ?.primaryFontColor ?? "rgb(1, 95, 235)"
                        }
                      />
                    </svg>
                  </div>
                </Tooltip>
              )}
            </div>
          )
        )}
      </div>
    </div>
  );
}

export default ConversationHeader;
